export const paymentStatuses = {
   open: 'OPEN',
   processing: 'PROCESSING',
   confirmed: 'PAYMENT_CONFIRMED',
   mismatch: 'MISMATCH',
};
